import ErrorPageView from 'page-sections/error/ErrorPageView';
export default function ErrorPage() {
  return <ErrorPageView />;
}